import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { concatMap, filter, tap } from 'rxjs/operators';
import { MsalBroadcastService } from '../msal';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {

  public SEC: boolean = false;
  public STB: boolean = false;
  public Directory: boolean = false;

  roles$: Observable<any> = null;
  private _roles: Array<any> = [];
  private boolSubject: Subject<any>;

  constructor(private serviceUsers: UserService, private msalBroadcastService: MsalBroadcastService) {
    this.boolSubject = new Subject<any>();
    this.roles$ = this.boolSubject.asObservable();
  }

  checkItHasRoles():  Observable<boolean> {
    return new Observable<boolean>(obs => {
      const roles = this.msalBroadcastService.msalSubject$.subscribe(resp => {
        if (resp['eventType'] === "msal:acquireTokenSuccess") {
          this.serviceUsers.getRoles().subscribe((resp) => {
            if (resp.roles != null) {
                if (resp.roles.includes('SEC_Minutes_Officer') || resp.roles.includes('SEC_Minutes_Officers') 
                || resp.roles.includes('Recording Searchers') || resp.roles.includes('directory') 
                || resp.roles.includes('Directorio Ejecutivo')) {
                  this._roles = resp.roles;
                  this.boolSubject.next(resp.roles)
                  obs.next(true);
                } else {
                  obs.next(false);
                }
            } else {
              obs.next(false);
            }
          }, (error) => {
            console.log(error);
          });
  
          roles.unsubscribe();
        }
      });

    });

  }

  getRoles() {
    return this._roles;
  }
}